import * as React from 'react';
import { connect } from 'react-redux';

import { IApplicationState } from '../../../types/redux';
import {
  ManifestationType,
  TotalAreaInput,
  KitchenAreaInput,
  LivingAreaInput,
  ApartmentType,
  PenthouseType,
  HouseType,
  NewbuildingClass,
  UndergroundWalkTimeInput,
  HasDecoration,
  ConstructionStatus,
  HasMortgage,
  SaleType,
} from '../../Filters';
import { Container } from '../../../components/Container';
import { Button } from '../../../components/Button';
import { Modal } from '../../../components/Modal';
import { Divider } from '../../../components/Divider';
import {
  SIZE_0, SIZE_8, SIZE_12, SIZE_24, SIZE_28, SIZE_30, SIZE_192,
  SIZE_WIDE, SIZE_440, SIZE_100, SIZE_20,
} from '../../../constants/sizes';
import { ADFOX_TIMEOUT } from '../../../constants/adfox';
import { TTypedThunkDispatch } from '../../../types/thunk';
import { getOffersData } from '../../../actions/offersData';
import { renderFieldRow } from './parts/renderFieldRow';
import { renderTitle } from './parts/renderTitle';
import { SearchButton } from '../../../components/SearchButton';
import { updateTags } from '../../../actions/filterTags';
import { openConsultantPopup as openConsultantPopupAction } from '../../../actions/newbuildingConsultant';
import { EAdFoxBannerType } from '../../Adfox/templates';
import { AdFoxBanner } from '../../Adfox';
import { Icon } from '../../../components/Icon';
import { NewbuildingConsultantInFilter } from '../../../components/NewbuildingConsultantInFilter';
import {
  trackingActionPopupMoreParamOpen,
  trackingActionPopupMoreParamShowObjectsClick,
} from '../../../actions/analytics';
import { isNewbuildingConsultantPopupAvailable } from '../../../selectors/newbuildingConsultant';

interface IModalStoreProps {
  count: number | null;
  isCountFetching?: boolean;
  hasUndreground: boolean;
  canUseHiddenBase: boolean;
  newbuildingConsultantPopup: boolean;
}

interface IModalDispatchProps {
  onSubmit(canUseHiddenBase: boolean): void;
  trackingPopupMoreParamOpen(): void;
  updateTags(): void;
  openConsultantPopup(): void;
}

interface IModalState {
  isOpen: boolean | undefined;
  bannerLoaded: boolean;
  bannerError: boolean;
}

type TModalProps = IModalStoreProps & IModalDispatchProps;

class MoreFiltersModalComponent extends React.PureComponent<TModalProps, IModalState> {
  public state: Readonly<IModalState> = {
    isOpen: false,
    bannerLoaded: false,
    bannerError: false,
  };
  private adTimer: number;
  public componentWillUnmount() {
    window.clearTimeout(this.adTimer);
  }
  public render() {
    const {
      count,
      isCountFetching,
      hasUndreground,
      newbuildingConsultantPopup,
    } = this.props;
    const { isOpen, bannerLoaded, bannerError } = this.state;

    return (
      <Container>
        <Modal
          onChange={this.handleChange}
          isOpen={isOpen}
          component={
            <>
              {!bannerLoaded &&
                <Container
                display="flex"
                justifyContent="center"
                width={SIZE_WIDE}
                position="absolute"
                top="calc(50% - 20px)"
                >
                  <Icon type="loader" color="blue" size={40}/>
                </Container>
              }
              <Container
                display="flex"
                visibility={bannerLoaded ? 'visible' : 'hidden'}
                flexDirection="column"
                justifyContent="space-between"
                height={SIZE_WIDE}
              >
                <Container
                  padding={`${SIZE_28} 0`}
                  overflow="auto"
                >
                  {!bannerError && <Container
                    margin={`0 ${SIZE_28} ${SIZE_12}`}
                    width={SIZE_440}
                    height={SIZE_100}
                  >
                    <AdFoxBanner
                      type={EAdFoxBannerType.PIK}
                      positionHint="hero"
                      onFail={this.handleAdfoxError}
                      onMount={this.handleAdfoxMount}
                    />
                  </Container>}
                  {renderFieldRow({
                    title: 'Тип объявления',
                    field: <ManifestationType />,
                  })}
                  {renderFieldRow({
                    title: 'Тип продажи',
                    field: <Container display="flex">
                      <SaleType />
                      <Container margin={`0 0 0 ${SIZE_20}`}>
                        <HasMortgage />
                      </Container>
                    </Container>,
                  })}
                  {renderTitle('О квартире')}
                  {renderFieldRow({
                    title: 'Площадь, м²',
                    field: <Container display="flex">
                      <Container width={SIZE_192}>
                        <TotalAreaInput />
                      </Container>
                      <Container width={SIZE_192} margin={`0 0 0 ${SIZE_24}`}>
                        <KitchenAreaInput />
                      </Container>
                      <Container width={SIZE_192} margin={`0 0 0 ${SIZE_24}`}>
                        <LivingAreaInput />
                      </Container>
                    </Container>,
                  })}
                  {renderFieldRow({
                    title: 'Отделка',
                    field: <Container display="flex">
                      <HasDecoration />
                    </Container>,
                  })}
                  {renderTitle('О жилом комплексе и корпусе')}
                  {renderFieldRow({
                    title: 'Тип дома',
                    field: <HouseType />,
                  })}
                  {renderFieldRow({
                    title: 'Класс жилого комплекса',
                  field: <NewbuildingClass />,
                  })}
                  {renderFieldRow({
                    title: 'Статус помещения',
                    field: <Container display="flex">
                      <ApartmentType />
                      <Container margin={`0 0 0 ${SIZE_8}`}>
                        <PenthouseType />
                      </Container>
                    </Container>,
                  })}
                  {hasUndreground && renderFieldRow({
                    title: 'До метро пешком',
                    field: <Container display="flex">
                      <UndergroundWalkTimeInput />
                    </Container>,
                  })}
                  {renderFieldRow({
                    title: 'Статус строительства',
                    field: <Container display="flex">
                      <ConstructionStatus />
                    </Container>,
                  })}
              </Container>
              <div>
                <Divider />
                <Container
                  padding={`${SIZE_0} ${SIZE_30}`}
                  minHeight="60px"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <SearchButton count={count} isCountFetching={isCountFetching} onClick={this.handleSubmit}/>
                  {newbuildingConsultantPopup && (
                    <NewbuildingConsultantInFilter onClick={this.handleOpenConsultantPopup} />
                  )}
                </Container >
              </div>
              </Container>
            </>
          }
        >
          <Button normalText={true} type="light" tabIndex={-1}>Ещё фильтры</Button>
        </Modal>
      </Container>
    );
  }

  private handleChange = (isOpen: boolean) => {
    if (isOpen) {
      this.props.trackingPopupMoreParamOpen();
      this.adTimer = window.setTimeout(this.handleAdfoxError, ADFOX_TIMEOUT);
    } else {
      this.props.updateTags(); //При закрытии модального окна обновляем тэги
    }
    this.setState({
      isOpen,
      bannerLoaded: false,
      bannerError: false,
    });
  }

  private handleSubmit = () => {
    this.props.onSubmit(this.props.canUseHiddenBase);
    this.setState({
      isOpen: false,
      bannerLoaded: false,
      bannerError: false,
    });
  }

  private handleAdfoxError = () => {
    this.setState({
      bannerLoaded: true,
      bannerError: true,
    });
  }

  private handleAdfoxMount = () => {
    window.clearTimeout(this.adTimer);
    this.setState({
      bannerLoaded: true,
      bannerError: false,
    });
  }

  private handleOpenConsultantPopup = () => {
    this.setState({
      isOpen: false,
      bannerLoaded: false,
      bannerError: false,
    });
    this.props.openConsultantPopup();
  }
}

function mapStateToProps(state: IApplicationState): IModalStoreProps {
  return {
    count: state.filters.offersCount.count,
    isCountFetching: state.filters.offersCount.isFetching,
    hasUndreground: state.region.currentRegion.hasMetro,
    canUseHiddenBase: state.user.isAuthenticated && state.user.permissions.canUseHiddenBase,
    newbuildingConsultantPopup: isNewbuildingConsultantPopupAvailable(state),
  };
}

function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    updateTags() { dispatch(updateTags()); },
    trackingPopupMoreParamOpen() { dispatch(trackingActionPopupMoreParamOpen()); },
    onSubmit: (canUseHiddenBase: boolean) => {
      dispatch(updateTags());
      dispatch(getOffersData({
        trackingAction: trackingActionPopupMoreParamShowObjectsClick,
        canUseHiddenBase,
      }));
    },
    openConsultantPopup() { dispatch(openConsultantPopupAction(true)); },
  };
}

export const MoreFiltersModal = connect(mapStateToProps, mapDispatchToProps)(MoreFiltersModalComponent);
